import getCMSObject from './getCMSObject';
var hasCMSContent = function (contentPath, module) {
    var _a;
    if (contentPath === void 0) { contentPath = ''; }
    if (module === void 0) { module = 'webContent'; }
    var content = (_a = getCMSObject(contentPath, module)) !== null && _a !== void 0 ? _a : '';
    return content && content.length && content.length > 0 ? true : false;
};
export default hasCMSContent;
